/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_Conversation_Too_LongInputs */



/**
* | output |
* | --- |
* | "This chat is too long for the agent. Start a new chat to continue." |
*
* @param {Assistant_Error_Conversation_Too_LongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_conversation_too_long = /** @type {((inputs?: Assistant_Error_Conversation_Too_LongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_Conversation_Too_LongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette conversation est trop longue pour l'agent. Veuillez démarrer une nouvelle conversation pour continuer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat ist für den Mitarbeiter zu lang. Starten Sie einen neuen Chat, um fortzufahren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa chat è troppo lunga per l'agente. Avvia una nuova chat per continuare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот чат слишком длинный для оператора. Начните новый чат, чтобы продолжить.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este chat es demasiado largo para el agente. Inicia un nuevo chat para continuar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本次聊天时间过长，客服人员无法继续。请重新开始聊天。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このチャットは長すぎるため、担当者が対応できません。続きを行うには、新しいチャットを開始してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह चैट एजेंट के लिए बहुत लंबी है। जारी रखने के लिए नई चैट शुरू करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esta conversa é muito longa para o agente. Inicie uma nova conversa para continuar.")
	return /** @type {LocalizedString} */ ("This chat is too long for the agent. Start a new chat to continue.")
});